import { EventEmitter, Output, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class CookiesUtil {

    constructor() { }

    getCookie(cname: string): string {
        let name = cname + '=';
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }

    setCookie(cname: string, cvalue: string, days?: number) {
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            let expires = '; expires=' + date.toUTCString();
            let path = '; path=/';
            document.cookie = cname + '=' + cvalue + expires + path;
        } else {
            document.cookie = cname + '=' + cvalue + '; path=/';
        }
    }

    deleteCookie(cname: string, cvalue: string) {
        let expires = '; expires=Thu, 01 Jan 1970 00:00:01 GMT';
        let path = '; path=/';
        document.cookie = cname + '=' + cvalue + expires + path;
    }
}
